var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyFaceBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.354 181.404C176.659 181.404 177.964 182.368 178.617 183.976C179.514 186.333 178.78 189.119 176.986 190.405C176.578 190.619 165.647 197.905 150.066 201.548C129.265 206.477 110.176 202.512 94.7587 190.19C93.0457 188.797 92.4747 185.904 93.5351 183.654C94.5956 181.404 96.7981 180.761 98.5111 182.047C132.201 209.049 173.315 182.154 173.723 181.94C174.266 181.583 174.81 181.404 175.354 181.404Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8942 87.3029C94.2328 83.3869 105.76 88.6082 109.681 98.8136C113.603 109.138 108.493 120.767 98.1543 124.683C87.8158 128.599 76.289 123.496 72.3675 113.172C68.3271 102.848 73.5557 91.3376 83.8942 87.3029Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.894 87.3029C181.233 83.3869 192.76 88.6082 196.681 98.8136C200.603 109.138 195.493 120.767 185.154 124.683C174.816 128.599 163.289 123.496 159.367 113.172C155.327 102.848 160.556 91.3376 170.894 87.3029Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 128,
    stroke: "black",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFaceBorder);
export default __webpack_public_path__ + "static/media/happy-face-border.ef7aac17d0c6fd5292bf4507b6af73e6.svg";
export { ForwardRef as ReactComponent };